module.exports = __webpack_public_path__ + "static/media/11.1e351c78.jpg";